// Luxe · Project Stage Section — premium stage divider that gives the
// workspace its six-stage visual hierarchy (Brief → Design → Visualise
// → Price → Proposal → Approval). Renders the stage anchor
// (id=`stage-<key>`) that ProjectStageHeader / Next Action scroll to.
// Kept restrained: understated overline + heading + one-line purpose.

export default function ProjectStageSection({ stageKey, label, purpose, state = "pending", children }) {
  const stateGlyph = state === "done" ? "\u2713" : state === "current" ? "\u25CF" : "\u25CB";
  const stateColor = state === "done" ? "text-emerald-700"
                    : state === "current" ? "text-foreground"
                    : "text-muted-foreground";
  return (
    <section id={`stage-${stageKey}`}
             data-testid={`project-stage-section-${stageKey}`}
             data-stage-state={state}
             className="scroll-mt-24">
      <header className="flex items-baseline justify-between gap-4 pb-3 mb-6 border-b border-border/80">
        <div className="min-w-0">
          <div className="overline text-[10px] text-muted-foreground">Stage</div>
          <h2 className="font-serif font-light mt-1 truncate" style={{ fontSize: "32px", lineHeight: 1.1 }}>{label}</h2>
          {purpose && (
            <p className="text-xs text-muted-foreground mt-2 max-w-2xl">{purpose}</p>
          )}
        </div>
        <div className={`text-[10px] uppercase tracking-widest ${stateColor} shrink-0`}
             data-testid={`stage-state-${stageKey}`}>
          <span aria-hidden className="mr-1.5">{stateGlyph}</span>
          {state === "done" ? "Done" : state === "current" ? "Current" : "Pending"}
        </div>
      </header>
      <div className="space-y-8">{children}</div>
    </section>
  );
}
